<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Rate Contract Report
    </div>
    <div class="card-body">
        <div class="row">

            <div class="col-md-6 my-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="data.BranchId" (change)="ComboLoad('Client');" placeholder="Select Branch"
                    #branch="ngModel">
                </ng-select>
            </div>

            <div class="col-md-6 my-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="data.ClientId" (change)="ComboLoad('Site');" placeholder="Select Client" required
                    #client="ngModel">
                </ng-select>
            </div>

            <div class="col-md-6 my-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="data.SiteId" placeholder="Select Site" (change)="ComboLoad('Designation')" required
                    #site="ngModel">
                </ng-select>
            </div>

            <div class="col-md-6 my-1">
                <label class="Label">Type</label>
                <ng-select name="type" [items]="Types" bindLabel="label" bindValue="value"
                    [(ngModel)]="data.Type" placeholder="Select Type" required [clearable]="false"
                    #type="ngModel">
                </ng-select>
            </div>

            <div class="col-md-auto my-1">
                <label class="Label"> Month Year </label>
                <div class="input-group">
                    <ngb-datepicker #dp name="monthyear" [(ngModel)]="data.MonthYear"
                        class="month-year small-datepicker"
                        (navigate)="data.MonthYear= $event.next;onNavigate($event)"></ngb-datepicker>
                </div>
            </div>



            <div class="col-auto my-2 ms-2">

                <label class="Label"> Status </label>
                <div>
                    <label class="Label px-2 mt-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='All' name="status" [(ngModel)]="data.Status"
                            [ngModelOptions]="{standalone: true}" required>
                        All
                    </label>
                    <label class="Label px-2" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='A' name="status"
                            [(ngModel)]="data.Status" [ngModelOptions]="{standalone: true}" required>
                        Active
                    </label>
                    <label class="Label px-2" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='D' name="status"
                            [(ngModel)]="data.Status" [ngModelOptions]="{standalone: true}" required>
                        Deactive
                    </label>

                </div>
            </div>

            <div class="col-auto my-1 ms-2 mt-4">
                <button type="button" (click)="ContractRateReport()" class="upload-btn" style="margin-top: 5px;" [disabled]="isDisabled">
                    <i class="bi bi-file-earmark-spreadsheet-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>

        </div>
    </div>
</div>